import { render, staticRenderFns } from "./indexQnz.vue?vue&type=template&id=fa8e981c&scoped=true"
import script from "./indexQnz.vue?vue&type=script&lang=js"
export * from "./indexQnz.vue?vue&type=script&lang=js"
import style0 from "./indexQnz.vue?vue&type=style&index=0&id=fa8e981c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8e981c",
  null
  
)

export default component.exports